const inputMixins = {
  data() {
    return {
      inputList: [],  // 控件数组
      inputTitle: [], // 控件名数组
      inputType: [],  // 控件类型数组
      tempInputList: [],  // 设置已选择控件为禁用的控件数组
      tempConditionList: [],  // 设置已选可见条件数组
      keyDepent: [], // 当前外键的从属字段数组
      showName: [] // 当前外键配置的显示字段数组
    }
  },
  methods: {
    getInputList() {  // 获取控件列表
      this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
        if (res.code == 200) {
          this.inputList = res.data
          _(this.inputList).forEach((res) => {
            this.inputTitle[res.default.field_id] = res.default.title
            this.inputType[res.default.field_id] = res.default.type
          })
          this.sortGroupId(this.form.field)
        }
        this.resetTempInputList()
      })
    },
    sortGroupId(fields) { // 整理分组id,去重，排序
      let curGroupIds = []
      if (fields.length != 0) {
        fields.forEach((res) => {
          curGroupIds.push(parseInt(res.group_id))
        })
        this.curGroupIds = Array.from(new Set(curGroupIds))
        this.curGroupIds.sort(this.sortNumber)
      }
    },
    resetTempInputList(field, ids) {  // 根据已选控件设置禁用状态
      let tempInputList = _.cloneDeep(this.inputList)
      let tempInputById = {}
      let key_cascade = {
        major_field: '',
        extra_field: ''
      }
      let option_relation = {
        major_field: '',
        relation: []
      }
      let person_struct_model = {
        major_field: '',
        filter_field: ''
      }
      if (field) {
        // 用临时数组保存所有控件权限
        _(field.inputs).forEach((res) => {
          let temp = {
            auth: res.field_auth,
            default: res.field_default != undefined ? res.field_default : null,
            key_major: res.key_major != undefined ? res.key_major : '',
            key_depent: res.key_depent != undefined ? res.key_depent : [],
            way: res.way != undefined ? res.way : 10,
            key_filter: res.key_filter != undefined && (_.isArray(res.key_filter)) ? res.key_filter : [], // 筛选条件
            key_fillin: res.key_fillin != undefined ? res.key_fillin : [],
            key_cascade: res.key_cascade != undefined ? res.key_cascade : _.cloneDeep(key_cascade),
            logic_condition: res.logic_condition != undefined ? res.logic_condition : [],
            option_relation: res.option_relation != undefined && !(_.isArray(res.option_relation)) ? res.option_relation : _.cloneDeep(option_relation),
            people_filter: res.people_filter != undefined ? res.people_filter : _.cloneDeep(person_struct_model),
            struct_filter: res.struct_filter != undefined ? res.struct_filter : _.cloneDeep(person_struct_model)
          }
          tempInputById[res.field_id] = temp
        })
        _(tempInputList).forEach((res) => {
          // 设置控件权限
          if (tempInputById[res.default.field_id]) {
            if (tempInputById[res.default.field_id].auth) {
              res.auth = tempInputById[res.default.field_id].auth
            } else {
              res.auth = this.INPUT_HIDDEN
            }
            res.field_default = tempInputById[res.default.field_id].default
            res.key_major = tempInputById[res.default.field_id].key_major
            res.key_depent = _.cloneDeep(tempInputById[res.default.field_id].key_depent)
            res.way = tempInputById[res.default.field_id].way
            res.key_filter = _.cloneDeep(tempInputById[res.default.field_id].key_filter)
            res.key_fillin = _.cloneDeep(tempInputById[res.default.field_id].key_fillin)
            res.key_cascade = _.cloneDeep(tempInputById[res.default.field_id].key_cascade)
            res.logic_condition = _.cloneDeep(tempInputById[res.default.field_id].logic_condition)
            res.option_relation = _.cloneDeep(tempInputById[res.default.field_id].option_relation)
            res.people_filter = _.cloneDeep(tempInputById[res.default.field_id].people_filter)
            res.struct_filter = _.cloneDeep(tempInputById[res.default.field_id].struct_filter)
          } else {
            res.auth = this.INPUT_HIDDEN
            res.field_default = null
            res.key_filter = []
            res.key_major = ''
            res.key_depent = []
            res.way = 10
            res.key_filter = []
            res.key_fillin = []
            res.key_cascade = _.cloneDeep(key_cascade)
            res.logic_condition = []
            res.option_relation = _.cloneDeep(option_relation)
            res.people_filter = _.cloneDeep(person_struct_model)
            res.struct_filter = _.cloneDeep(person_struct_model)
          }
          if (_.findIndex(ids, (id) => {
            return id == res.default.field_id
          }) > -1) {
            // 控件已存在别的分组
            res.disabled = true
          }
        })
      }
      this.tempInputList = tempInputList
      // console.log('this.tempInputList', this.tempInputList)
    },
    resetTempConditionList(list) {
      this.tempConditionList = list
    },
    showInputConfig() { // 显示页面布局配置弹窗
      this.$refs.inputConfig.openDialog()
      this.$refs.inputConfig.setCurField(this.form.field)
    },
    // showDeleteConfirmDialog(value) {  // 控制删除分组弹窗是否显示
    //   this.deleteShow = value
    // },
    // confirmDelete() { // 确定删除分组
    //   this.$refs.inputConfig.deleteGroup()
    //   this.deleteShow = false
    // },
    showDeleteConfirmDialog(value) {  // 控制删除分组弹窗是否显示
      this.deleteShow = value
    },
    setConditionListShow(value) { // 控制可见条件弹窗是否显示
      if (value.show) {
        // if (value.item.group == '') {
        //   _g.toastMsg(this, 'error', '请先填写分组名')
        //   return
        // }
        this.$refs.conditionList.openDialog()
        this.$refs.conditionList.getGroupName(value.item)
      } else {
        this.$refs.conditionList.closeDialog()
      }
    },
    confirmDelete() { // 确定删除分组
      this.$refs.inputConfig.deleteGroup()
      this.deleteShow = false
    },
    setNewInputList(newInputList) { // 确定当前分组的控件配置
      this.$refs.inputConfig.setNewInputList(newInputList)
    },
    setNewConditionList(newInputList) { // 确定当前分组的可见条件
      this.$refs.inputConfig.setNewConditionList(newInputList)
    },
    setConditionList(conditions) { // 确定可见条件控件配置
      this.$refs.inputConfig.setConditionList(conditions)
    },
    setInputListShow(value) { // 设置控件列表是否显示
      if (value) {
        this.$refs.inputList.openDialog()
      } else {
        this.$refs.inputList.closeDialog()
      }
    },
    setKeyDepent(keyDepent, showName) {
      this.keyDepent = keyDepent
      this.showName = showName
    },
    confirmDepentConfig(keyDepent) {
      this.$refs.inputList.confirmDepentConfig(keyDepent)
    }
  }
}

export default inputMixins



// WEBPACK FOOTER //
// ./src/components/Content/abstract/dealConfig/inputMixins.js